import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import SocialLinkModal from "../Common_profile_details_modals/SocialLinkModal/SocialLinkModal";

function SocialLinksCard() {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");

  const [selectedLink, setSelectedLink] = useState({
    link: "",
  });

  const socialLinks = [
    {
      link: "https://linkedin.com/in/smita-lad-b917a1215",
    },
  ];

  const handleClose = () => {
    setShowModal(false);
  };

  const handleAdd = () => {
    setModalMode("add");
    setSelectedLink({
      link: "",
    });
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setModalMode("edit");
    setSelectedLink(item);
    setShowModal(true);
  };

  return (
    <>
      <Card className="profile-card-pattern profile-pattern-expandable">
        <Card.Body className="profile-card-pattern__body">
          {/* Header */}
          <div className="profile-card-pattern__header">
            <h2 className="profile-card-pattern__title">
              Social Links
            </h2>

            <Button
              variant="link"
              className="profile-card-pattern__btn-add"
              onClick={handleAdd}
            >
              <span className="summary-card__edit-icon">
                ➕
              </span>
            </Button>
          </div>

          {/* Links */}
          {socialLinks.map((item, index) => (
            <div
              className="profile-pattern-expandable__nested-row"
              key={index}
            >
              <i className="fa-brands fa-linkedin profile-pattern-expandable__brand-icon"></i>

              <span className="profile-pattern-expandable__link-text">
                {item.link}
              </span>

              <Button
                variant="link"
                className="profile-card-pattern__btn-edit"
                onClick={() => handleEdit(item)}
              >
                <span className="summary-card__edit-icon">
                  ✏️
                </span>
              </Button>
            </div>
          ))}
        </Card.Body>
      </Card>

      <SocialLinkModal
        show={showModal}
        handleClose={handleClose}
        mode={modalMode}
        socialLink={selectedLink}
      />
    </>
  );
}

export default SocialLinksCard;